const getters = {
  getBanks: (state) => state.banks,
  getBank: (state) => state.bank,
  getCheckAccountNumber: (state) => state.isValidAccountNumber,
};

export default getters;
